<ion-header>
  <ion-toolbar color="secondary">
    <div class="header-title">
      <div class="item item-back">
        <ion-img
          [src]="'assets/icon/arrow.svg'"
          [alt]="'...'"
          (click)="dismissModal()"
        ></ion-img>
      </div>
      <div class="item">
        <h1>CRÉDITO BLOQUEADO</h1>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content>
  <section class="main">
    <h2>$ Saldo Disponível</h2>
    <h3>
      É todo crédito de recarga, recebimento de transferência e de recompensa
      recebido ao realizar suas compras em nossos parceiros.
    </h3>

    <h3>
      Este saldo pode ser utilizado para efetuar compras, realizar
      transferências e ainda ganhar muito mais!
    </h3>
    <h2><span>$ Saldo Bloqueado</span></h2>
    <h3>
      No Colapp toda a compra você ganha recompensa. Que tal ganhar 25% mais de
      recompensa?
    </h3>

    <h3>
      Simples, torne-se PRIME e todo o montante acumulado AQUI é imediatamente
      disponibilizado para uso em sua carteira.
    </h3>

    <h1>PRIME</h1>

    <h3>Com tantos benefícios assim o colapp não tem como ficar melhor né?</h3>

    <h3>Tem sim!</h3>

    <div class="footer">
      <ion-img
        src="assets/images/credits/blocked.png"
        alt="Quero ser PRIME"
      ></ion-img>
      <h3>Ajude muito mais pessoas a</h3>
      <h3>ganharem também.</h3>
      <ion-button (click)="onClickMore()" color="dark"> SAIBA MAIS </ion-button>
    </div>
  </section>
</ion-content>
